export default __webpack_public_path__ + "static/media/eua-flag.a78e91b9.svg";